import BaseModel from './BaseModel';

export class BloodPressure extends BaseModel {
  constructor(public systolic: number, public diastolic: number) {
    super();
  }

  toString(): string {
    return `BloodPressure: Systolic ${this.systolic} | Diastolic ${this.diastolic}`;
  }

  toJSON() {
    return {
      systolic: this.systolic,
      diastolic: this.diastolic,
    };
  }
}
